import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanyRegular from './company-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanyRegular {...validProps} />;
}

SvgComponent.iconName = 'company-regular';

export const CompanyRegularIcon = svgIconWrapper(SvgComponent);
